<template>
    <div class="blackBg  animate__animated animate__slideInLeft">
        <div class="cardTit">
            <span class="teamName">{{ teamName ? teamName : 'XXX' }}</span>
            <p class="date">
                <!--                <span class="week"><span>第 {{ nowWeek }} 周</span></span>-->
                <span class="today">{{ dateArray[(dateInd - 1) < 0 ? 0 : (dateInd - 1)] }}</span>
            </p>
        </div>
        <div class="barDate cardBg">
            <p v-if="playersNameList.length" class="barTit PingFang">{{ dateBar ? dateBar.name : '' }}</p>
            <div v-show="playersNameList.length" id="gpsBar" style="height: 100%;width: 100%"></div>
            <div v-show="!playersNameList.length" style="line-height: 21vw;font-size: 26px;text-align: center;">暂无数据
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "athleticPerformance",
    computed: {
        teamId() {
            return this.$store.state.teamId;
        }
    },
    watch: {
        teamId: {
            handler(val, old) {
                if (val != old) {
                    this.teamName = this.$store.state.teamName.split('_')[0];//梯队名称
                    this.dateInd = 0;
                    this.info();
                }
            },
            deep: true
        },
        paramsCommandFn: {
            handler(val, old) {
            },
            deep: true
        }
    },
    data() {
        return {
            teamName: this.$store.state.teamName.split('_')[0],//梯队名称
            nowWeek: '',//当前周
            playersNameList: [],//球员list
            GPSItem: [],
            dateBar: null,//当前柱状图数据
            time: null,//定时器
            dateInd: 0,//查看的是七天内日期的index
            dateArray: [],//近七天的日期
            beforeDestroy: false,
        }
    },
    mounted() {
        this.sevenDay();
        this.getFilter();
    },
    methods: {
        sevenDay() {
            //设置日期，当前日期的前七天
            let myDate = new Date(); //获取今天日期
            myDate.setDate(myDate.getDate() - 6);
            this.dateArray = [];
            let dateTemp;
            let flag = 1;
            for (let i = 0; i < 6; i++) {
                dateTemp = this.$global.formatDate(new Date(myDate.getFullYear() + '/' + (myDate.getMonth() + 1) + "/" + myDate.getDate()), 'yyyy/MM/dd', true);
                this.dateArray.unshift(dateTemp);
                myDate.setDate(myDate.getDate() + flag);
            }
            this.dateArray.unshift(this.$global.formatDate(new Date(), 'yyyy/MM/dd', new Date()));
            this.nowWeekFn();
            this.info();
        },
        info() {
            this.$server.weekOfYear({date: this.dateArray[this.dateInd]})
                .then(year => {
                    let data = {
                        teamId: this.teamId,
                        date: this.dateArray[this.dateInd],
                        year: year.data.year
                    }
                    if (this.dateInd == this.dateArray.length) {
                        this.dateInd = 0;
                    } else {
                        this.dateInd++
                    }
                    this.gpsReportFn(data)
                })
        },
        //  获取gps 筛选项
        getFilter() {
            let data = {
                teamId: this.teamId
            }
            this.$server.getGpsFilter(data).then(res => {
                if (res.code === 200) {
                    this.GPSItem = [];
                    if (res.data && res.data.length) {
                        let arr = [];
                        res.data.map(item => {
                            if (item.gps) {
                                // console.log(item.slug)
                                arr.push({
                                    ...item,
                                    playerNameAll: [],
                                    allData: [],
                                })
                            }

                        })
                        this.GPSItem = arr;
                    }
                }
            })
        },
        //当前周
        nowWeekFn() {
            this.$server.nowWeek()
                .then((res) => {
                    this.nowWeek = res.data;
                })
        },
        //gps --总数据
        gpsReportFn(data) {
            this.$server.gpsReport(data)
                .then((res) => {
                    this.GPSItem.forEach(item => {
                        item.playerNameAll = []
                        item.allData = []
                    })

                    let GPSData = res.data;
                    if (GPSData != null && GPSData != undefined && GPSData.length > 0) {
                        GPSData.forEach((item) => {
                            let obj = {}
                            item.data.map(slug => {
                                if (!obj[slug.slug]) {
                                    obj[slug.slug] = slug
                                }
                            })

                            item['slugData'] = obj;
                            this.GPSItem.forEach(gps => {
                                if (item.slugData[gps.slug]) {
                                    gps.allData.push({
                                        value: Number(item.slugData[gps.slug].value).toFixed(item.slugData[gps.slug].decimal),
                                        timeFormat: gps.timeFormat,
                                        name: item.slugData[gps.slug].name
                                    })
                                    // gps.allData.push(item.slugData[gps.slug].value * 1)
                                    let name = item.playerName
                                    gps.playerNameAll.push(name)
                                    gps.playerNameAll = [...new Set(gps.playerNameAll)]
                                }
                            })
                        })

                        clearInterval(this.time);
                        if (res.data.length) {
                            this.playersNameList = this.GPSItem[0].playerNameAll;
                            setTimeout(() => {
                                this.weekBarData(this.GPSItem);
                            })
                        }
                    } else {
                        console.log(this.dateInd + '空数据');
                        clearTimeout();
                        if (!this.beforeDestroy) {
                            let T = setTimeout(() => {
                                this.info();
                            }, 5000);
                        }
                    }

                })
        },
        //柱状图
        weekBarData(data) {
            if (!data.length) {
                return
            }
            let barWidth = 20;//柱状图默认宽度

            this.dateBar = data[0];
            if (!this.dateBar.allData.length) {
                return
            }
            // 指定图表的配置项和数据
            let myChart = this.$echarts.init(document.getElementById('gpsBar'));
            var labelOption = {
                show: true,
                position: 'top',
                distance: 15,
                fontSize: 18,
                color: '#5FCA83',
                formatter: (params) => {
                    if (params.data.timeFormat) {
                        const time = Number(params.value)
                        if (Number.isNaN(time)) {
                            return ''
                        } else {
                            return this.$global.timeFormat(time)
                        }
                    } else {
                        return params.value
                    }
                }
            };

            myChart.setOption({
                grid: {
                    x: 40,
                    y: 10,
                    right: 30,
                    top: 40,
                    bottom: 120,
                    left: 60,
                    borderWidth: 1
                },
                //  ------  X轴 ------
                xAxis: {
                    show: true,  // 是否显示
                    nameGap: 15, // 坐标轴名称与轴线之间的距离
                    nameRotate: 20,  // 坐标轴名字旋转
                    axisLabel: {
                        color: 'rgba(255, 255, 255, .5)',
                        rotate: 60,
                        fontSize: 18,
                        margin: 30,     // 刻度标签与轴线之间的距离
                    },
                    axisLine: {       // 坐标轴 轴线
                        show: true,  // 是否显示
                        // ------   线 ---------
                        lineStyle: {
                            color: 'rgba(255, 255, 255, .5)',
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisTick: {    // 坐标轴 刻度
                        show: false,  // 是否显示
                    },
                    data: this.playersNameList
                },
                //   ------   y轴  ----------
                yAxis: {
                    show: true,  // 是否显示
                    nameTextStyle: {    // 坐标轴名称样式
                        color: '#fff',
                        padding: [5, 0, 0, 5]  // 坐标轴名称相对位置
                    },
                    nameGap: 15, // 坐标轴名称与轴线之间的距离

                    axisLine: {    // 坐标轴 轴线
                        show: false,  // 是否显示
                        // ----- 线 -------
                        lineStyle: {
                            color: '#616162',
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisTick: {      // 坐标轴的刻度
                        show: true,    // 是否显示
                        inside: true,  // 是否朝内
                        length: 3,      // 长度
                        lineStyle: {
                            color: '#616162',  // 默认取轴线的颜色
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisLabel: {      // 坐标轴的标签
                        show: true,    // 是否显示
                        inside: false,  // 是否朝内
                        rotate: 0,     // 旋转角度
                        marginRight: 5,     // 刻度标签与轴线之间的距离
                        color: 'rgba(255, 255, 255, .5)',  // 默认轴线的颜色
                        fontSize: '14'
                    },
                    splitLine: {    // gird 区域中的分割线
                        show: true,   // 是否显示
                        lineStyle: {
                            color: 'rgba(255, 255, 255, .2)',
                            width: 1,
                            type: 'dashed'
                        }
                    },
                },
                //  -------   内容数据 -------
                series: [
                    {
                        type: 'bar',      // 类型
                        label: labelOption,
                        itemStyle: {    // 图形的形状
                            normal: {
                                //柱形图圆角，初始化效果
                                barBorderRadius: [3, 3, 0, 0],
                                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: '#34C955'
                                },
                                    {
                                        offset: 1,
                                        color: '#6EFF8E'
                                    }])
                            }
                        },
                        barWidth: barWidth,  // 柱形的宽度
                        // barGap:'10%',
                        // barCategoryGap: '20%',  // 柱形的间距

                        data: thisBarDataInfo,
                    }
                ]
            });
            //初始数据
            var thisBarDataInfo = [];//第一次加载
            let timeInfo = null;
            let indInfo = 0;
            // console.log(this.dateBar)
            timeInfo = setInterval(() => {
                if (this.dateBar.allData[indInfo] != null || this.dateBar.allData[indInfo] != undefined) {//判断当前位置
                    thisBarDataInfo.push(this.dateBar.allData[indInfo]);
                    indInfo++

                    myChart.setOption({
                        series: [
                            {
                                data: thisBarDataInfo
                            }
                        ],
                    });
                } else {
                    clearInterval(timeInfo)
                }

            }, 90)

            //间隔变换数据
            this.time = setInterval(() => {
                barWidth == 15 ? barWidth = 20 : barWidth = 15;
                myChart.setOption({
                    series: [
                        {
                            barWidth: barWidth,  // 柱形的宽度
                        }
                    ],
                });
                let barShowTime = null;
                barShowTime = setTimeout(() => {
                    if (this.GPSItem.indexOf(this.dateBar) == (this.GPSItem.length - 1)) {
                        // this.dateBar = this.GPSItem[0]
                        this.info();
                    } else {
                        this.dateBar = this.GPSItem[this.GPSItem.indexOf(this.dateBar) + 1]
                    }
                    // console.log(this.dateBar)
                    let thisBarData = [];
                    let time = null;
                    let ind = 0;
                    time = setInterval(() => {

                        if (this.dateBar.allData[ind] != null || this.dateBar.allData[ind] != undefined) {
                            thisBarData.push(this.dateBar.allData[ind]);
                            ind++

                            myChart.setOption({
                                series: [
                                    {
                                        itemStyle: {    // 图形的形状
                                            normal: {
                                                // color: 'var(--primary-color)'
                                                //柱形图圆角，初始化效果
                                                barBorderRadius: [2, 2, 0, 0],
                                                // color: this.barColorFn
                                            }
                                        },
                                        barWidth: barWidth,  // 柱形的宽度
                                        data: thisBarData
                                    }
                                ],
                            });
                        } else {
                            clearInterval(time)
                        }

                    }, 90)
                }, 1000);
            }, 10000)
        },
    },
    beforeDestroy() {
        this.beforeDestroy = true;
        clearInterval(this.time)
    },
    deactivated() {
        clearInterval(this.time)
    }
}
</script>

<style scoped lang="less">
.cardTit {
    background-image: url("../assets/img/updateImg/head_2.png");
    position: relative;
    font-size: 30px;

    .date {
        font-family: PingFangMedium;
        color: #fff;
        display: inline-block;
        line-height: 120px;
        position: absolute;
    }

    .date {
        right: 2vw;
        display: inline-block;

        .week {
            margin-right: 2vw;
        }
    }
}

.barDate {
    padding: 2vw;
    box-sizing: border-box;
    height: calc(100% - 115px);

    #gpsBar {
        padding-top: 1vw;
    }

    .barTit {
        color: #fff;
        font-size: 28px;
    }
}
</style>
